import axios from "axios";

// Debug logging
console.log('🔍 API Configuration Debug:', {
    'window.env exists': !!window.env,
    'window.env': window.env,
    'window.env.REACT_APP_API_BASE_URL': window.env?.REACT_APP_API_BASE_URL,
    'process.env.REACT_APP_API_BASE_URL': process.env.REACT_APP_API_BASE_URL,
});

const apiBaseUrl = (window.env && window.env.REACT_APP_API_BASE_URL) || process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api";

console.log('✅ Selected API Base URL:', apiBaseUrl);

export const api = axios.create({
    baseURL: apiBaseUrl,
    withCredentials: true,
});

export default api;
